import Chip from "components/chip";
import Link from "next/link";

import clsx from "clsx";
import dayjs from "dayjs";
import { formattedDate, formattedTime, humanizedTime } from "utils/date";
import { FiZoomIn } from "react-icons/fi";

export default function Questionnaire(props) {
  const { id, number, correctCount, totalCount, completedAt, createdAt } =
    props;
  const { loading } = props;

  function timeTaken() {
    const startTime = dayjs(completedAt);
    const diff = startTime.diff(createdAt, "second");
    return humanizedTime(diff);
  }

  function correctText() {
    return `${correctCount} acerto${correctCount === 1 ? "" : "s"}`;
  }

  return (
    <div
      className={`questionnaire p-4 bg-white border border-t-2 border-gray-50 border-t-primary-300 rounded-b-lg shadow fade-loading ${clsx(
        { loading }
      )}`}
    >
      <div className="flex items-center justify-between mb-2">
        <span className="number text-2xl font-bold leading-tight">
          #{number}
        </span>
        <div className="mx-4 overflow-hidden">
          <FiltersBadge {...props} />
        </div>
        <div className="completed-at flex flex-col items-end">
          <span className="text-emphasis-low text-xs">
            {formattedDate(completedAt)}
          </span>
          <span className="mt-1 text-emphasis-low text-xs">
            {formattedTime(completedAt)}
          </span>
        </div>
      </div>
      <div className="flex items-end justify-between">
        <div>
          <span className="block text-2xl">
            <span>{correctText()}</span>{" "}
            <span className="whitespace-nowrap">de {totalCount}</span>
          </span>
          <span className="block mt-2 text-emphasis-medium text-sm">
            Tempo levado: {timeTaken()}
          </span>
        </div>
        <div className="icon-wrapper p-2 cursor-pointer">
          <Link href={`/desempenho/${id}`}>
            <a>
              <FiZoomIn size={32} />
            </a>
          </Link>
        </div>
      </div>
    </div>
  );
}

function FiltersBadge(props) {
  const { institution, year, subject, name } = props;
  const filters =
    [institution, year, subject, name].filter((item) => !!item).join(" | ") ||
    "Questões aleatórias";

  return (
    <Chip
      text={filters}
      className="whitespace-nowrap overflow-hidden"
      color="bg-gray-100"
    />
  );
}
